import React from "react";
import "./style.css";
import caddyLogo from "../../assets/images/png/golfer.png";

export default function Loading({ visible }) {
  if (!visible) return null;

  return (
    <div className="loading-container">
      <div className="walking-caddy-container">
        <div className="golf-course-line"></div>
        <img src={caddyLogo} alt="Loading" className="walking-caddy" />
        <div className="footsteps">
          <div className="footstep footstep-1"></div>
          <div className="footstep footstep-2"></div>
          <div className="footstep footstep-3"></div>
        </div>
      </div>
      <div className="loading-text">
        <p>กำลังโหลด ...</p>
        <div className="loading-dots">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </div>
  );
}
